






















































































































































































































import { ValidationProvider, ValidationObserver } from "vee-validate";
import cInput from "@/components/FormElements/CustomInput.vue";
import { Vue, Component, Watch } from "vue-property-decorator";
import ebSelect from "@/components/FormElements/Select.vue";
import DatePicker from "vuejs-datepicker";
@Component({
  components: {
    cInput,
    DatePicker,
    ebSelect,
    ValidationProvider,
    ValidationObserver,
  },
})
export default class Agreement extends Vue {
  // computed
  get getwayoption() {
    return [
      {
        label: "COD",
        value: "COD",
      },
      {
        label: "Cash Free",
        value: "CASHFREE",
      },
      {
        label: "Paytm",
        value: "PAYTM",
      },
    ];
  }
  get businessPlanList() {
    return this.$store.getters["businessPlan/GetBusinessPlanList"];
  }
  get catalogsOptions() {
    let catalogs = this.$store.getters["catalog/GetCatalogTree"];
    let filtercatalogs = [];
    filtercatalogs = catalogs.filter((obj) => obj.isDomain) || [];
    return filtercatalogs;
  }
  @Watch("agreement.keys")
  onChange(newVal, oldVal) {
    this.agreement.paymentOptionKeys = [];
    newVal.forEach((element) => {
      this.agreement.paymentOptionKeys.push(element.value);
    });
  }
  private filtercatalogs = [];
  private agreement: any = {
    enableManufacturer: false,
    selectMarket: false,
    paymentOptionKeys: [],
    keys: "",
    appkeyCashFree: "",
    secretkeyCashFree: "",
    appkeyPaytm: "",
    secretkeyPaytm: "",
    market: null,
    catalog: null,
    doc: "",
    plan: "",
    valid: {
      from: new Date(),
      to: new Date(),
    },
  };
  private readAgreement(e) {
    this.uploadFile(e.target.files[0]);
  }
  private async marketList() {
    this.filtercatalogs = [];
    this.agreement.market = [];
    let data = this.agreement.catalog;
    try {
      if (Array.isArray(data) && data.length > 0) {
        let searchString = "";
        data.forEach(async (el) => {
          searchString = `parent=${el._id}`;
          await this.$store.dispatch("catalog/fetchCatalogList", searchString);
          this.filtercatalogs.push(
            ...this.$store.getters["catalog/GetCategoryList"].data.response
          );
        });
      }
    } catch {
      this.filtercatalogs = [];
    }
    if (Array.isArray(data) && data.length == 0) {
      this.filtercatalogs = [];
    }
  }
  // upload file to the S3 bucket
  private async uploadFile(file) {
    let formdata = new FormData();
    formdata.append("file", file);
    formdata.append(
      "key",
      (
        Date.now().toString(36) + Math.random().toString(36).substr(2, 5)
      ).toLowerCase()
    );
    formdata.append("isPublic", JSON.stringify(true));
    formdata.append("replaceExisting", JSON.stringify(true));
    formdata.append("basePath", "tenant");
    this.showCustomToast();
    await this.$store
      .dispatch("inventory/uploadFileToStorage", formdata)
      .then((res) => {
        this.agreement.doc = res.data.fileUrl;
        this.clearCustomToast();
      })
      .catch((error) => {
        this.$swal({
          type: "error",
          text: "File Upload failed! please try again.",
        });
        this.clearCustomToast();
      });
  }
  private showCustomToast() {
    Vue.toasted.show("Uploading...", {
      type: "info",
      theme: "toasted-primary",
      singleton: true,
      duration: 1000000,
    });
  }
  private clearCustomToast() {
    Vue.toasted.clear();
  }
  isValid() {
    const isValid = this.$refs.observer.validate();
    return isValid;
  }
  private mounted() {
    this.$store.dispatch("catalog/fetchCatalogTree");
    this.$store.dispatch("businessPlan/businessPlanList");
  }
}
